import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import ProgressLoader from "../Reports/DeliveryReports/ProgressLoader";
import LinearProgress from "@mui/material/LinearProgress";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
// import { common_axios } from "../../../../App";
import { common_axios } from "../../../App";
import Swal from "sweetalert2";
// import Loader from "../../../../components/Loader";
import Loader from "../../../components/Loader";
import { Backdrop } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Tooltip } from "@mui/material";
function LinearProgressWithLabel(props) {
  // console.log({ props });

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "122px", mr: "auto", ml:"auto" }}>
        <LinearProgress
          //   color="green"className="mt-1"
          className="mt-1"
          sx={{
            "& .MuiLinearProgress-bar1Determinate": {
              backgroundColor: props.colorr,
            },
          }}
          variant="determinate"
          {...props}
        />
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
  color: PropTypes.number.isRequired,
};

const DownloadExportData = ({ downloadData }) => {
  const [open, setOpen] = useState();
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [hitTableData, setHitTableData] = useState(true);
  const [TableStatus, setTableStatus] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
// console.log("first",downloadData)
  useEffect(() => {
    if (downloadData?.content) {
      setData(downloadData?.content);
      setData1(downloadData);
    }
  }, [downloadData]);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [Status, setStatus] = useState("allUser");

  const defaultColumn = useMemo(() => {
    return {
      // Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    setSelectedUserDetailApprove(null);
    await modelButtonReject.current.click();
  };
  const [MenuItemPhoneBook, setMenuItemPhoneBook] = useState(undefined);

  // async function DownloadTabApi(values) {
  //   setData([]);
  //   try {
  //     setOpen(true);
  //     const result = await common_axios.post(
  //       `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/delivery-report/get/v1/download/report`,
  //       {
  //         pageNo: TableStatus?.pageNo,
  //         pageSize: TableStatus?.pageSize,
  //       }
  //     );
  //     // console.log("------resultssss", result);
  //     if (result.data.statusDescription.statusCode == 200) {
  //       setOpen(false);
  //       setData1(result.data?.downloadReport);
  //       setData(result.data?.downloadReport?.content);
  //     } else {
  //       setOpen(false);
  //       setData([]);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: result.data.statusDescription.statusMessage,
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }
  //   } catch (error) {
  //     setOpen(false);

  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Please Check Your Network",
  //       // footer: '<a href="">Why do I have this issue?</a>'
  //     });
  //   }
  //   // console.log("response..", res);
  // }
  async function DownloadTabApi() {
    setOpen(true);
    try {
      // setHideSkeleton(true)
      if(MenuItemPhoneBook == 0 ){
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
          // {
          //   pageNo: Status?.pageNo,
          //   pageSize: Status?.pageSize,
          // }
  
          {
            downloadReportRequest: {
                reportType:"phonebook",
                pageNo: TableStatus?.pageNo,
                pageSize: TableStatus?.pageSize,
            }
        }
        );
        if (result.data.statusdescription.statusCode == 200) {
          setData1(result.data?.downloadReport);
          setData(result.data?.downloadReport?.content);
                    setOpen(false);
          // const butt = document.getElementById("Download-tab");
          // butt.click();
        } else {
          setData([])
          setOpen(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusdescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
     else{
      setOpen(true);
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
        // {
        //   pageNo: Status?.pageNo,
        //   pageSize: Status?.pageSize,
        // }
        {
          downloadReportRequest: {
              reportType:"Bulk group",
              pageNo: TableStatus?.pageNo,
              pageSize: TableStatus?.pageSize,
          }
      }
      );
      if (result.data.statusdescription.statusCode == 200) {
        // DownloadTabApi()
        setData1(result.data?.downloadReport);
        setData(result.data?.downloadReport?.content);
        setOpen(false);
        // const butt = document.getElementById("Download-tab");
        // butt.click();
      } else {
        // setData([])
  
        setOpen(false);
  
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusdescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
     }
     
    } catch (error) {
      setOpen(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
// ...................................................Refresh Button Api............................................................//

async function RefreshBtn() {
  setOpen(true);
  setData([])
  try {
    // setHideSkeleton(true)
    if(MenuItemPhoneBook == 0 ){
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
        // {
        //   pageNo: Status?.pageNo,
        //   pageSize: Status?.pageSize,
        // }

        {
          downloadReportRequest: {
              reportType:"phonebook",
              pageNo: TableStatus?.pageNo,
              pageSize: TableStatus?.pageSize,
          }
      }
      );
      if (result.data.statusdescription.statusCode == 200) {
        setData1(result.data?.downloadReport);
        setData(result.data?.downloadReport?.content);
                  setOpen(false);
        const butt = document.getElementById("Download-tab");
        butt.click();
      } else {
        setData([])

        setOpen(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusdescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
   else{
    setOpen(true);
    const result = await common_axios.post(
      `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
      // {
      //   pageNo: Status?.pageNo,
      //   pageSize: Status?.pageSize,
      // }

      {
        downloadReportRequest: {
            reportType:"Bulk group",
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
        }
    }
    );
    if (result.data.statusdescription.statusCode == 200) {
      // DownloadTabApi()
      setData1(result.data?.downloadReport);
      setData(result.data?.downloadReport?.content);
      setOpen(false);
      // const butt = document.getElementById("Download-tab");
      // butt.click();
    } else {
      // setData([])

      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: result.data.statusdescription.statusMessage,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
   }
   
  } catch (error) {
    setOpen(false);
    // toast.error("Please Check Your Network",{
    //   toastId: customId1,
    //   theme: "colored",
    // });
    Swal.fire({
      icon: "error",
       title: "Oops...",
      text:"Please Check Your Network",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
  }
}

// ..................................................................................................................................//
  useEffect(() => {
    if (hitTableData == false) {
      DownloadTabApi();
    }
  }, [TableStatus?.pageNo, TableStatus?.pageSize]);

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        Cell: (cell) => (
          <>
            {cell?.row?.index + 1 + TableStatus?.pageNo * TableStatus?.pageSize}
          </>
        ),
      },
      {
        Header: "Phonebook / Bulkgroup Name ",
        accessor: "event", // accessor is the "key" in the data
      
      },
      {
        Header: "Report Type",
        accessor: "reportType", // accessor is the "key" in the data
      
      },
      {
        Header: "File Name",

        accessor: "fileName", // accessor is the "key" in the data
        // Cell: (cell) => {
        //   return <>{dateFormatter(cell.row.original.datetimeEntry)}</>;
        // },
      },
      {
        Header: "FileCreatedDate",

        accessor: "fileCreatedDate",
      },
      {
        Header: "Requested By",

        accessor: "requestedBy", // accessor is the "key" in the data
        // Cell: (cell) => {
        //   return <>{dateFormatter(cell.row.original.datetimeScheduled)}</>;
        // },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: (cell) => {
          return (
            <>
              {cell?.row?.original?.file_status == false ? (
                <>
                  <p style={{ fontSize: "12px" }} className="process_txt">In Process</p>
                  <ProgressLoader />
                </>
              ) : cell?.row?.original?.file_status == true ? (
                <>
                  <p style={{ fontSize: "12px" }} className="text-center fw-bold">Completed</p>
                  <LinearProgressWithLabel
                    colorr={
                      cell?.row?.original?.file_status == true
                        ? "green"
                        : "blue"
                    }
                  />
                </>
              ) : (
                // colorr={"blue"}

                // value={Math.round((0/ 0) * 100)}

                {
                  /* <div className="badge badge_8 bg-success">Complete</div> */
                }
              )}
            </>
          );
        },
      },
      {
        Header: "Download",
        Footer: "Download",
        // accessor: "downloadUrl",

        Cell: (cell) => {
          return (
            <>
              {cell?.row?.original?.file_status == false ? (
                <></>
              ) : cell?.row?.original?.file_status == true ? (
                <>
                  <div className="">
                    <button
                      className="btn color_1 px-2"
                      type="button"
                      id=""
                      data-bs-toggle=""
                      aria-expanded="false"
                      onClick={() => {
                        downloadFile(cell);
                      }}
                    >
                      <FileDownloadIcon />
                    </button>
                  </div>
                </>
              ) : (
                // colorr={"blue"}

                // value={Math.round((0/ 0) * 100)}

                {
                  /* <div className="badge badge_8 bg-success">Complete</div> */
                }
              )}
            </>
          );
        },

        // Cell: (cell) => (
        //   <div className="">
        //     <button
        //       className="btn color_1 px-2"
        //       type="button"
        //       id=""
        //       data-bs-toggle=""
        //       aria-expanded="false"
        //       onClick={() => {
        //         downloadFile(cell);
        //       }}
        //     >
        //       <FileDownloadIcon />
        //     </button>
        //   </div>
        // ),
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  const downloadFile = async (cell) => {
    try {
      const response = await common_axios.get(
        `${cell?.row?.original?.downloadUrl}?UserId=${localStorage.getItem(
          "UserId"
        )}&Source="web"`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/vnd.ms-excel" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `excel-file.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.error(error);
    }
  };
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">

      <Backdrop
            sx={{
              transform: "translateZ(0)",
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
            // onClick={handleClose}
          >
            <Loader />
          </Backdrop>
        <div className="container-fluid px-0">
          {/* <div className="card mb-3 mt-4"> */}
         
          <div className="card-body px-0">
            {/* ------------------------------Table---------------------------------- */}
            {data?.length > 0 ? (
              <>
                <div>
                  <div class="card-body px-0 mt-2">
                    <div>
                      <div></div>
                    </div>
                    {/* <div className="d-flex justify-content-between my-3">
                      <select
                        value={TableStatus.pageSize}
                        className="form-select select_8 p-2"
                        // className="form-select select_8 p-2"
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setTableStatus({
                            ...TableStatus,
                            pageSize: e.target.value,
                            pageNo: 0,
                          });
                          setHitTableData(false);
                        }}
                      >
                        {[10, 25, 50].map((value, i) => {
                          return (
                            <option
                              className=""
                              aria-labelledby="dropdownMenuButton1"
                              value={value}
                              key={value}
                            >
                              Show {value}
                            </option>
                          );
                        })}
                      </select> */}

                      <div className="d-flex justify-content-between my-3">
                              <select
                                  value={TableStatus.pageSize}
                                className="dropdown"
                                onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setTableStatus({
                            ...TableStatus,
                            pageSize: e.target.value,
                            pageNo: 0,
                          });
                          setHitTableData(false);
                        }}
                              >
                                {[10, 25, 50].map((value, i) => {
                                  return (
                                    <option
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                      value={value}
                                      key={value}
                                    >
                                      {" "}
                                      Show {value}
                                    </option>
                                  );
                                })}
                              </select>
                            
                         
                            <Tooltip title="Refresh">
                  <button
                    type="submit"
                    className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                    // onClick={RefreshBtn}
                    onClick={() => RefreshBtn("Text to Copy")}
                  >
                    {/* <i class="material-icons opacity-10">refresh</i> */}
                    <RefreshIcon />
                  </button>
                </Tooltip>
                           
                    </div>

                    <div>
                      {selectedFlatRows.length > 0 && (
                        <button onClick={deletUser}>Delete Users</button>
                      )}

                      {/* <button onClick={changeOrder}>Change Order</button> */}
                    </div>
                    <div className="table-responsive">
                      <table
                        {...getTableProps()}
                        id="example"
                        className="table table-striped table-bordered dataTable table-sm"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  )}
                                  // className="text-center width_2"
                                  className={
                                    column.Header == "Action"
                                      ? "p-sticky text-center width_2"
                                      : "text-center width_2"
                                  }
                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted
                                      ? column.isSortedDesc
                                        ? "↑"
                                        : "↓"
                                      : ""}
                                  </span>

                                  {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="text-center">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })} */}

                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                  {
                                    {/* console.log({ cell }); */}
                                  }
                                  return (
                                    <td
                                      {...cell.getCellProps()}
                                      // className={
                                      //   cell.column.Header == "RegExp NPI" ||
                                      //   cell.column.Header == "RegExp TON" ||
                                      //   cell.column.Header == "Id"
                                      //     ? "text-end"
                                      //     : cell.column.Header == "Action"
                                      //     ? "p-sticky table-column-gray"
                                      //     : ""
                                      // }
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                        {/* <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td className="text-center" {...column.getFooterProps}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot> */}
                      </table>
                    </div>
                    <div className="d-flex justify-content-between mt-4">
                      <div>
                        <span>
                          Page:
                          <strong>
                            {data1?.pageable?.pageNumber + 1} of{" "}
                            {data1?.totalPages}
                          </strong>
                        </span>
                      </div>

                      <div className="d_flex_1 mt_3">
                        <button
                          className="btn btn_primary btn_4 m-0"
                          type="button"
                          style={{ background: "#2C97D4" }}
                          disabled={data1?.pageable?.pageNumber == 0}
                          onClick={() => {
                            setTableStatus({
                              ...TableStatus,
                              pageNo: TableStatus.pageNo - 1,
                            });
                            setHitTableData(false);
                          }}
                        >
                          Prev
                        </button>

                        <button
                          className="btn btn_primary ms-2 btn_4 m-0"
                          type="button"
                          style={{ background: "#2C97D4" }}
                          disabled={
                            data1?.totalPages == data1?.pageable?.pageNumber + 1
                          }
                          onClick={() => {
                            setTableStatus({
                              ...TableStatus,
                              pageNo: TableStatus.pageNo + 1,
                            });
                            setHitTableData(false);
                          }}
                        >
                          Next
                        </button>
                        {/* <button
                onClick={() => {
                  gotoPage(pageCount - 1);
                }}
                disabled={!canNextPage}
              >
                {">>"}
              </button> */}
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                  {/* </div> */}
                  {/* <pre>
        <code>
          {JSON.stringify(
            {
              selectFlatRows: selectedFlatRows.map((row) => row.original),
            },
            null,
            2
          )}
        </code>
      </pre> */}
                </div>
              </>
            ) : (
              <>
                {/* <p className="text-center m-0 mt-3 no_data">Data not Found</p> */}
                <div className="text-center m-0 mt-3 no_data">
                  {data?.length == 0 && open == true ? null : data?.length ==
                      0 && open == undefined ? null : (
                    <div className="text-center">
                      <h5>Data Not Found</h5>
                    </div>
                  )}
                </div>
              </>
            )}

            {/* ----------------------------------ENd table----------------------------------- */}
          </div>
          {/* </div> */}
        </div>
      </main>
    </>
  );
};

export default DownloadExportData;
